/**
 * merchant-intake routes. Paths are the public contract; keep them exact.
 */

import { Route } from 'react-router-dom';

import {
  IntakeLineRedirect,
  LandingPage,
  MerchantProfileRoute,
} from './LandingPage.js';
import { ProductionLineSetupPage } from './ProductionLineSetupPage.js';

/** Routes reachable before sign-in: the landing page and the intake preview. */
export function merchantIntakePublicRoutes() {
  return (
    <>
      <Route path="/" element={<LandingPage />} />
      <Route path="/business-profile" element={<MerchantProfileRoute />} />
    </>
  );
}

/**
 * Intake-scoped continuations the server still hands out; composed inside
 * the merchant workspace shell, which resolves them to the Production Line
 * behind the intake.
 */
export function merchantIntakeShellRoutes() {
  return (
    <>
      <Route
        path="/merchant/intakes/:intakeId/production-lines/new"
        element={<ProductionLineSetupPage />}
      />
      <Route path="/merchant/intakes/:intakeId" element={<IntakeLineRedirect />} />
      <Route
        path="/merchant/intakes/:intakeId/recommendations"
        element={<IntakeLineRedirect />}
      />
    </>
  );
}
